// extracted by mini-css-extract-plugin
export default {"boxIllustration":"n01XfdPmMuR75cGqE8xF"};